module.exports = __webpack_public_path__ + "img/cloud-raining-06.57248ba2.svg";